import { Providers } from '~/api/types/connectionData.ts';

export enum AuthMethodsConnectionTypes {
  SAML = 'SAML',
  OIDC = 'OIDC',
  OAUTH = 'OAUTH',
  PASSWORDLESS = 'PASSWORDLESS',
  WEBAUTHN = 'WEBAUTHN'
}

export enum PasswordLessAuthTypes {
  OTP = 'OTP',
  LINK = 'LINK',
  LINK_OTP = 'LINK_OTP'
}

export interface AuthMethodData {
  connectionId: string;
  connectionType: AuthMethodsConnectionTypes;
  provider: Providers;
  authInitiationUri?: string;
  passwordlessType?: PasswordLessAuthTypes;
  enableWebauthnConditionalLogin?: boolean;
  enableWebauthnAutoRegistration?: boolean;
  showPasskeyButton?: boolean;
}
